'use client';

import { useMediaQuery } from 'usehooks-ts';

const screens = {
  // Screens should be same as in app/store-web/tailwind.config.js -> theme.extend.screens
  // You can use different projects settings how it's done here wagmi.ts -> metadataConfig
  sm: '568px',
  md: '768px',
  lg: '992px',
  xl: '1280px',
  '2xl': '1400px',
  '3xl': '1920px',
};

type BreakpointMode = 'min' | 'max';
type BreakpointName = keyof typeof screens | string; // also allowing custom media query strings

function generateQuery(screenName: BreakpointName, mode: BreakpointMode): string {
  if (screenName.includes('width')) {
    return screenName; // if it's a custom media query string, return it directly
  }

  // If it's one of the predefined names, generate the query using mode and screen size
  return `(${mode}-width: ${screens[screenName as keyof typeof screens]})`;
}

export function useBreakpoint(screenName: BreakpointName, mode: BreakpointMode = 'min'): boolean {
  const query = generateQuery(screenName, mode);

  return useMediaQuery(query);
}
